import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "حاسبة الفرق بين تاريخين - احسب الفرق بين تاريخين بدقة";
const DESCRIPTION =
  "احسب الفرق بين تاريخين في التقويم الميلادي بدقة. حاسبة الفرق بين تاريخين تعرض لك الفرق بالسنوات والشهور والأيام والساعات والدقائق والثواني، مع معلومات تفصيلية إضافية";
const KEYWORDS =
  "حاسبة الفرق بين تاريخين, حساب الفرق بين تاريخين, الفرق بين تاريخين ميلادي, حساب المدة بين تاريخين, حاسبة الفرق الزمني, حساب الفرق بين عمرين, الفرق بالأيام بين تاريخين, حساب الفترة الزمنية";
const OG_URL = "https://do-calculate.com/calculator/ar/dategregoriandifferences/";

const GREGORIAN_MONTHS = [
  "كانون الثاني", "شباط", "آذار", "نيسان", "أيار", "حزيران",
  "تموز", "آب", "أيلول", "تشرين الأول", "تشرين الثاني", "كانون الأول"
];

const SCHEMA = [
  {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "حاسبة الفرق بين تاريخين",
    description: DESCRIPTION,
    url: OG_URL,
    applicationCategory: "UtilityApplication",
    operatingSystem: "Any",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "الرئيسية",
        item: "https://do-calculate.com/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "الحاسبات",
        item: "https://do-calculate.com/ar/all-calculators/",
      },
      {
        "@type": "ListItem",
        position: 3,
        name: "حاسبة الفرق بين تاريخين",
        item: OG_URL,
      },
    ],
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: [
      {
        "@type": "Question",
        name: "كيف أحسب الفرق بين تاريخين؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "لحساب الفرق بين تاريخين، أدخل التاريخ الأول والتاريخ الثاني في الحقول المخصصة، ثم اضغط على زر الحساب. ستظهر لك النتيجة بالسنوات والأشهر والأيام والساعات والدقائق والثواني.",
        },
      },
      {
        "@type": "Question",
        name: "ما هي استخدامات حاسبة الفرق بين تاريخين؟",
        acceptedAnswer: {
          "@type": "Answer",
          text: "تُستخدم حاسبة الفرق بين تاريخين في حساب مدة المشاريع، حساب الفترة الزمنية بين الأحداث، حساب مدة العمل أو الخدمة، التخطيط للمناسبات، وحساب الفارق العمري بين شخصين.",
        },
      },
    ],
  },
];
function DateCalculatorGregorian() {
  const [d1, setD1] = useState({ day: "7", month: "2", year: "2026" });
  const [d2, setD2] = useState({ day: "13", month: "2", year: "2026" });
  const [differences, setDifferences] = useState(null);
  const [error, setError] = useState(null);

  const calculateDifferences = () => {
    const date1 = new Date(parseInt(d1.year), parseInt(d1.month) - 1, parseInt(d1.day));
    const date2 = new Date(parseInt(d2.year), parseInt(d2.month) - 1, parseInt(d2.day));

    if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
      setError("يُرجى إدخال تواريخ صحيحة");
      setDifferences(null);
      return;
    }

    let startDate = date1 < date2 ? date1 : date2;
    let endDate = date1 < date2 ? date2 : date1;

    let years = endDate.getFullYear() - startDate.getFullYear();
    let months = endDate.getMonth() - startDate.getMonth();
    let days = endDate.getDate() - startDate.getDate();

    if (days < 0) {
      months--;
      const lastMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
      days += lastMonth.getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }

    const totalMilliseconds = endDate - startDate;
    const totalSeconds = Math.floor(totalMilliseconds / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);
    const totalWeeks = Math.floor(totalDays / 7);
    const totalMonths = years * 12 + months;

    // حساب النسبة المئوية من القرن (100 سنة)
    const yearPercentage = (totalDays / (100 * 365.25)) * 100;

    setDifferences({
      years, months, days,
      hours: 0, minutes: 0, seconds: 0, // بما أن الإدخال باليوم فقط
      totalDays, totalWeeks, totalMonths, totalHours, totalMinutes, totalSeconds,
      startDate: startDate.toLocaleDateString("ar-EG", { weekday: "long", year: "numeric", month: "long", day: "numeric" }),
      endDate: endDate.toLocaleDateString("ar-EG", { weekday: "long", year: "numeric", month: "long", day: "numeric" }),
      yearPercentage: yearPercentage.toFixed(2),
      solarYears: (totalDays / 365.25).toFixed(2),
      workDays: Math.floor((totalDays / 7) * 5),
    });
    setError(null);
  };

  const renderSelectGroup = (data, setData, label) => (
    <div className="mb-4">
      <label ><strong>{label}:</strong></label>
      <div className="row">
        <div className="col-md-4">
          <select className="form-control" value={data.day} onChange={(e) => setData({ ...data, day: e.target.value })}>
            {Array.from({ length: 31 }, (_, i) => i + 1).map(d => <option key={d} value={d}>{d}</option>)}
          </select>
        </div>
        <div className="col-md-4">
          <select className="form-control" value={data.month} onChange={(e) => setData({ ...data, month: e.target.value })}>
            {GREGORIAN_MONTHS.map((m, i) => <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>)}
          </select>
        </div>
        <div className="col-md-4">
          <select className="form-control" value={data.year} onChange={(e) => setData({ ...data, year: e.target.value })}>
            {Array.from({ length: 200 }, (_, i) => 2100 - i).map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
      </div>
    </div>
  );

  return (
    <div className="rtl" style={{ direction: "rtl", textAlign: "right" }}>
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />

      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
          <br />
          <div className="bg-success text-white text-center p-3 rounded shadow-sm">
            <h1 style={{ fontSize: "22px", margin: 0 }}>حاسبة الفرق بين تاريخين</h1>
          </div>

          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div className="mb-4">
              <p style={{ fontSize: "16px", lineHeight: "1.8" }}>
                <strong>حاسبة الفرق بين تاريخين</strong> تمكنك من حساب الفرق الزمني بين أي تاريخين في التقويم الميلادي بدقة فائقة. تعرض لك الحاسبة الفرق بالسنوات والشهور والأيام والساعات والدقائق والثواني، بالإضافة إلى معلومات تفصيلية مفيدة.
              </p>
            </div>
            <hr />
            <MobileUnderCalAds />

            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>احسب الفرق بين تاريخين</h2>
              </div>

              {renderSelectGroup(d1, setD1, "التاريخ الأول")}
              {renderSelectGroup(d2, setD2, "التاريخ الثاني")}

              <div className="text-center mb-3 mt-4">
                <button className="btn btn-success btn-lg" style={{ padding: "10px 40px" }} onClick={calculateDifferences}>
                  احسب الفرق بين التاريخين
                </button>
              </div>

              {error && <div className="alert alert-warning text-center">{error}</div>}

              {differences && (
                <div className="mt-4 animate__animated animate__fadeIn">
                  <div className="alert alert-success" style={{ color: "#155724", backgroundColor: "#d4edda", borderColor: "#c3e6cb" }}>
                    <h3 style={{ fontSize: "20px", marginBottom: "15px" }}><strong>نتيجة حساب الفرق بين التاريخين:</strong></h3>
                    <div className="mb-3 p-3 bg-light rounded text-dark border">
                      <strong style={{ fontSize: "18px" }}>الفرق بين التاريخين هو:</strong>
                      <p style={{ fontSize: "22px", marginTop: "10px", fontWeight: "bold", color: "#28a745" }}>
                        {differences.years} سنة و {differences.months} شهر و {differences.days} يوم
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    {/* الفرق بالتفصيل */}
                    <div className="col-md-6 mb-3">
                      <div className="card h-100 shadow-sm">
                        <div className="card-header bg-success text-white"><strong>الفرق بالتفصيل الدقيق</strong></div>
                        <div className="card-body">
                          <ul className="list-unstyled" style={{ fontSize: "16px", lineHeight: "2" }}>
                            <li>✓ السنوات: {differences.years}</li>
                            <li>✓ الأشهر: {differences.months}</li>
                            <li>✓ الأيام: {differences.days}</li>
                            <li>✓ الساعات: {differences.hours}</li>
                            <li>✓ الدقائق: {differences.minutes}</li>
                            <li>✓ الثواني: {differences.seconds}</li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    {/* إحصائيات إجمالية */}
                    <div className="col-md-6 mb-3">
                      <div className="card h-100 shadow-sm">
                        <div className="card-header bg-success text-white"><strong>إحصائيات إجمالية</strong></div>
                        <div className="card-body">
                          <ul className="list-unstyled" style={{ fontSize: "16px", lineHeight: "2" }}>
                            <li>📅 إجمالي الأيام: {differences.totalDays.toLocaleString()} يوم</li>
                            <li>📅 إجمالي الأسابيع: {differences.totalWeeks.toLocaleString()} أسبوع</li>
                            <li>📅 إجمالي الأشهر: {differences.totalMonths.toLocaleString()} شهر</li>
                            <li>⏰ إجمالي الساعات: {differences.totalHours.toLocaleString()} ساعة</li>
                            <li>⏰ إجمالي الدقائق: {differences.totalMinutes.toLocaleString()} دقيقة</li>
                            <li>⏰ إجمالي الثواني: {differences.totalSeconds.toLocaleString()} ثانية</li>
                            <li>💼 أيام العمل التقريبية: {differences.workDays.toLocaleString()} يوم (بافتراض 5 أيام عمل أسبوعياً)</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* معلومات تفصيلية */}
                  <div className="card mb-3 shadow-sm">
                    <div className="card-header bg-success text-white"><strong>معلومات تفصيلية عن التاريخين</strong></div>
                    <div className="card-body">
                      <p><strong>التاريخ الأول:</strong> {differences.startDate}</p>
                      <p><strong>التاريخ الثاني:</strong> {differences.endDate}</p>
                      <hr />
                      <p><strong>هذه الفترة تمثل:</strong></p>
                      <ul style={{ lineHeight: "2" }}>
                        <li>{differences.yearPercentage}% من قرن (100 سنة)</li>
                        <li>{differences.solarYears} سنة شمسية</li>
                        <li>{Math.floor(differences.totalDays / 30)} شهر تقريباً</li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <hr />
            <RelatedLinks />
          </div>
        </div>

        <div className="col-md-4">
          <SecondAds />
          <br />
          <MainCalculatorsList />
        </div>
      </div>
      {/* Informational Content */}
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <strong>ما هي حاسبة الفرق بين تاريخين؟</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  <strong>حاسبة الفرق بين تاريخين</strong> هي أداة إلكترونية
                  متطورة تقوم بحساب الفروقات الزمنية بين تاريخين في التقويم
                  الميلادي بدقة فائقة. تعتمد الحاسبة على معادلات برمجية دقيقة
                  تأخذ في الاعتبار جميع العوامل المؤثرة مثل:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>السنوات الكبيسة والعادية</li>
                  <li>اختلاف عدد أيام الأشهر</li>
                  <li>الساعات والدقائق والثواني</li>
                  <li>فروقات التوقيت</li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  كيفية استخدام الحاسبة:
                </h3>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>أدخل التاريخ الأول في الحقل المخصص</li>
                  <li>أدخل التاريخ الثاني في الحقل المخصص</li>
                  <li>اضغط على زر "احسب الفرق بين التاريخين"</li>
                  <li>ستظهر النتائج فوراً بتفاصيل شاملة</li>
                </ol>
                <p style={{ lineHeight: "1.8" }}>
                  الحاسبة تقوم تلقائياً بترتيب التواريخ، لذا لا يهم أي التاريخين
                  تدخل أولاً. ستحصل على النتيجة بالقيمة المطلقة للفرق بين
                  التاريخين.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>استخدامات حاسبة الفرق بين تاريخين</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  الاستخدامات الشخصية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>حساب الفارق العمري:</strong> معرفة الفرق في العمر
                    بين شخصين (الأشقاء، الأزواج، الأصدقاء)
                  </li>
                  <li>
                    <strong>حساب مدة العلاقة:</strong> معرفة كم مضى على الزواج
                    أو الخطوبة أو الصداقة
                  </li>
                  <li>
                    <strong>التخطيط للمناسبات:</strong> حساب الوقت المتبقي أو
                    المنقضي منذ مناسبة معينة
                  </li>
                  <li>
                    <strong>الذكريات:</strong> معرفة كم مضى على حدث مهم في حياتك
                  </li>
                  <li>
                    <strong>الأهداف:</strong> حساب المدة التي قضيتها في تحقيق
                    هدف معين
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  الاستخدامات المهنية والعملية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>إدارة المشاريع:</strong> حساب مدة المشروع الفعلية
                    ومقارنتها بالمخطط
                  </li>
                  <li>
                    <strong>الموارد البشرية:</strong> حساب مدة الخدمة للموظفين
                  </li>
                  <li>
                    <strong>المحاسبة:</strong> حساب فترات الفوترة والدفع
                  </li>
                  <li>
                    <strong>القانون:</strong> حساب المدد القانونية والمواعيد
                    النهائية
                  </li>
                  <li>
                    <strong>التأمين:</strong> حساب فترات التغطية التأمينية
                  </li>
                  <li>
                    <strong>العقود:</strong> حساب مدة سريان العقود والاتفاقيات
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  الاستخدامات الطبية والصحية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>حساب عمر الحمل بدقة</li>
                  <li>متابعة فترات العلاج والتعافي</li>
                  <li>حساب الفترات بين الجرعات والفحوصات</li>
                  <li>تتبع النمو والتطور للأطفال</li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  الاستخدامات التعليمية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>حساب مدة الفصل الدراسي أو السنة الأكاديمية</li>
                  <li>حساب الوقت المتبقي للامتحانات</li>
                  <li>تتبع مدة الدراسة لإكمال شهادة أو برنامج</li>
                  <li>التخطيط للعطلات الدراسية</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>كيفية حساب الفرق بين تاريخين يدوياً</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  حساب الفرق بين تاريخين يدوياً عملية معقدة تتطلب عدة خطوات:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  الخطوات الأساسية:
                </h3>
                <ol style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>حساب الأيام:</strong> اطرح اليوم الأول من اليوم
                    الثاني. إذا كانت النتيجة سالبة، أضف عدد أيام الشهر السابق
                    وانقص شهراً واحداً.
                  </li>
                  <li>
                    <strong>حساب الأشهر:</strong> اطرح الشهر الأول من الشهر
                    الثاني. إذا كانت النتيجة سالبة، أضف 12 شهراً وانقص سنة واحدة.
                  </li>
                  <li>
                    <strong>حساب السنوات:</strong> اطرح السنة الأولى من السنة
                    الثانية.
                  </li>
                </ol>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  التحديات في الحساب اليدوي:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>الأشهر المختلفة:</strong> بعض الأشهر 30 يوماً وبعضها
                    31 يوماً، وفبراير 28 أو 29 يوماً
                  </li>
                  <li>
                    <strong>السنوات الكبيسة:</strong> يجب مراعاة السنوات الكبيسة
                    التي تحتوي على 366 يوماً
                  </li>
                  <li>
                    <strong>الساعات والدقائق:</strong> حساب الفروقات بالساعات
                    والدقائق يتطلب دقة أكبر
                  </li>
                  <li>
                    <strong>الوقت المستهلك:</strong> العملية قد تستغرق عدة دقائق
                    وقد تحتوي على أخطاء حسابية
                  </li>
                </ul>
                <div
                  className="alert alert-info mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>💡 نصيحة:</strong> استخدام الحاسبة الإلكترونية أسرع
                  وأدق بكثير من الحساب اليدوي. توفر لك الوقت والجهد وتضمن الدقة
                  100%.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>فهم النتائج والإحصائيات</strong>
              </div>
              <div className="info-section-body">
                <p style={{ lineHeight: "1.8" }}>
                  تعرض حاسبة الفرق بين تاريخين مجموعة شاملة من النتائج
                  والإحصائيات التي تساعدك على فهم الفترة الزمنية بشكل أفضل:
                </p>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  النتائج الأساسية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>السنوات والأشهر والأيام:</strong> الفرق الأساسي
                    بصيغة سهلة القراءة
                  </li>
                  <li>
                    <strong>الساعات والدقائق والثواني:</strong> للحصول على دقة
                    أكبر
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  الإحصائيات الإضافية:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>إجمالي الأيام:</strong> العدد الكلي للأيام بين
                    التاريخين، مفيد للحسابات المالية والتخطيط
                  </li>
                  <li>
                    <strong>إجمالي الأسابيع:</strong> عدد الأسابيع الكاملة، مفيد
                    للتخطيط الأسبوعي
                  </li>
                  <li>
                    <strong>إجمالي الأشهر:</strong> العدد الكلي للأشهر، مفيد
                    للاشتراكات والفواتير الشهرية
                  </li>
                  <li>
                    <strong>إجمالي الساعات:</strong> العدد الكلي للساعات، مفيد
                    لحساب ساعات العمل
                  </li>
                  <li>
                    <strong>أيام العمل التقريبية:</strong> عدد أيام العمل
                    (بافتراض 5 أيام عمل أسبوعياً)، مفيد للموارد البشرية وإدارة
                    المشاريع
                  </li>
                </ul>
                <h3 style={{ fontSize: "17px", marginTop: "15px" }}>
                  كيفية استخدام هذه الإحصائيات:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    استخدم <strong>إجمالي الأيام</strong> لحساب الفوائد اليومية
                    أو الإيجارات
                  </li>
                  <li>
                    استخدم <strong>إجمالي الأسابيع</strong> لتخطيط المشاريع
                    الأسبوعية
                  </li>
                  <li>
                    استخدم <strong>إجمالي الأشهر</strong> للاشتراكات والعقود
                    الشهرية
                  </li>
                  <li>
                    استخدم <strong>أيام العمل</strong> لحساب الرواتب والأجور
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>نصائح لاستخدام الحاسبة بفعالية</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  نصائح عامة:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>
                    <strong>تأكد من صحة التواريخ:</strong> تحقق دائماً من أن
                    التواريخ المدخلة صحيحة ومنطقية
                  </li>
                  <li>
                    <strong>استخدم التنسيق الصحيح:</strong> أدخل التواريخ
                    بالتنسيق المطلوب (YYYY-MM-DD)
                  </li>
                  <li>
                    <strong>لا يهم الترتيب:</strong> يمكنك إدخال التاريخ الأحدث
                    أولاً أو الأقدم أولاً، الحاسبة ستحسب الفرق تلقائياً
                  </li>
                  <li>
                    <strong>احفظ النتائج:</strong> إذا كنت بحاجة للنتائج لاحقاً،
                    التقط صورة للشاشة أو انسخ النتائج
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  للحصول على أفضل النتائج:
                </h3>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>استخدم التواريخ الدقيقة إذا كانت متاحة</li>
                  <li>راجع جميع الإحصائيات المعروضة للحصول على فهم شامل</li>
                  <li>استخدم النتائج المناسبة لاحتياجاتك (أيام، أسابيع، أشهر)</li>
                  <li>قارن بين عدة فترات زمنية إذا لزم الأمر</li>
                </ul>
                <div
                  className="alert alert-success mt-3"
                  style={{ lineHeight: "1.8" }}
                >
                  <strong>✓ ميزة:</strong> جميع الحسابات تتم في متصفحك بشكل
                  فوري، مما يضمن الخصوصية والسرعة.
                </div>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <strong>أمثلة عملية على استخدام الحاسبة</strong>
              </div>
              <div className="info-section-body">
                <h3 style={{ fontSize: "17px", marginBottom: "10px" }}>
                  مثال 1: حساب مدة الزواج
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  إذا تزوجت في 15 يونيو 2010 وتريد معرفة كم مضى على زواجك:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>التاريخ الأول: 2010-06-15</li>
                  <li>التاريخ الثاني: التاريخ الحالي</li>
                  <li>النتيجة: ستحصل على عدد السنوات والأشهر والأيام بدقة</li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  مثال 2: حساب مدة المشروع
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  بدأ مشروعك في 1 يناير 2023 وانتهى في 31 ديسمبر 2023:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>التاريخ الأول: 2023-01-01</li>
                  <li>التاريخ الثاني: 2023-12-31</li>
                  <li>
                    النتيجة: 364 يوماً (أو حوالي 11 شهراً و29 يوماً)، مع عدد
                    أيام العمل التقريبية
                  </li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  مثال 3: حساب الفارق العمري
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  ولد الشخص الأول في 10 مارس 1990 والثاني في 25 يوليو 1995:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>التاريخ الأول: 1990-03-10</li>
                  <li>التاريخ الثاني: 1995-07-25</li>
                  <li>النتيجة: الفارق العمري بينهما بالضبط</li>
                </ul>
                <h3
                  style={{
                    fontSize: "17px",
                    marginTop: "15px",
                    marginBottom: "10px",
                  }}
                >
                  مثال 4: حساب مدة الخدمة
                </h3>
                <p style={{ lineHeight: "1.8" }}>
                  بدأ الموظف العمل في 1 سبتمبر 2018:
                </p>
                <ul style={{ lineHeight: "1.8" }}>
                  <li>التاريخ الأول: 2018-09-01</li>
                  <li>التاريخ الثاني: التاريخ الحالي</li>
                  <li>
                    النتيجة: مدة الخدمة الكاملة مع عدد أيام العمل التقريبية،
                    مفيد لحساب المكافآت والإجازات
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <br />
          <h2 style={{ fontSize: "20px", marginBottom: "15px" }}>
            أسئلة متكررة
          </h2>
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف أحسب الفرق بين تاريخين؟
                </h3>
              </div>
              <div className="info-section-body">
                لحساب الفرق بين تاريخين باستخدام حاسبتنا، اتبع الخطوات التالية:
                <ol style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>أدخل التاريخ الأول في الحقل المخصص</li>
                  <li>أدخل التاريخ الثاني في الحقل المخصص</li>
                  <li>اضغط على زر "احسب الفرق بين التاريخين"</li>
                  <li>
                    ستظهر النتيجة فوراً بالسنوات والأشهر والأيام والساعات
                    والدقائق والثواني، بالإضافة إلى إحصائيات تفصيلية أخرى
                  </li>
                </ol>
                لا يهم أي التاريخين تدخل أولاً، فالحاسبة ستحسب الفرق المطلق
                تلقائياً.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يمكن حساب الفرق بين تاريخين بالأيام فقط؟
                </h3>
              </div>
              <div className="info-section-body">
                نعم، عند استخدام الحاسبة، ستحصل على نتائج شاملة تتضمن "إجمالي
                الأيام" بين التاريخين. هذا الرقم يمثل العدد الكلي للأيام بين
                التاريخ الأول والتاريخ الثاني، وهو مفيد جداً للحسابات المالية مثل
                الفوائد اليومية، أو حساب الإيجارات، أو تتبع المشاريع. بالإضافة
                إلى ذلك، ستحصل أيضاً على إجمالي الأسابيع والأشهر والساعات
                والدقائق والثواني.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ما هي استخدامات حاسبة الفرق بين تاريخين؟
                </h3>
              </div>
              <div className="info-section-body">
                حاسبة الفرق بين تاريخين لها استخدامات متعددة:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>
                    <strong>شخصياً:</strong> حساب الفارق العمري، مدة العلاقات،
                    الذكريات
                  </li>
                  <li>
                    <strong>مهنياً:</strong> إدارة المشاريع، حساب مدة الخدمة،
                    فترات الفوترة
                  </li>
                  <li>
                    <strong>قانونياً:</strong> حساب المدد القانونية والمواعيد
                    النهائية
                  </li>
                  <li>
                    <strong>طبياً:</strong> حساب عمر الحمل، فترات العلاج
                  </li>
                  <li>
                    <strong>تعليمياً:</strong> مدة الفصول الدراسية، الوقت المتبقي
                    للامتحانات
                  </li>
                  <li>
                    <strong>مالياً:</strong> حساب فترات الاستثمار، مدة القروض
                  </li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل الحاسبة دقيقة في حساب الفرق بين التاريخين؟
                </h3>
              </div>
              <div className="info-section-body">
                نعم، حاسبتنا دقيقة جداً. تستخدم معادلات برمجية متطورة تأخذ في
                الاعتبار:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>السنوات الكبيسة (التي تحتوي على 366 يوماً)</li>
                  <li>
                    اختلاف عدد أيام الأشهر (بعضها 30 يوماً، وبعضها 31، وفبراير
                    28 أو 29)
                  </li>
                  <li>الحساب الدقيق للساعات والدقائق والثواني</li>
                  <li>جميع العوامل الزمنية الأخرى</li>
                </ul>
                الحاسبة تعطي نتائج دقيقة 100% وفورية، وهي أدق بكثير من الحساب
                اليدوي الذي قد يحتوي على أخطاء.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل يمكن حساب الفرق بين تاريخين في الماضي؟
                </h3>
              </div>
              <div className="info-section-body">
                نعم، يمكنك استخدام الحاسبة لحساب الفرق بين أي تاريخين، سواء كانا
                في الماضي أو أحدهما في الماضي والآخر في المستقبل أو الحاضر.
                الحاسبة مرنة وتقبل أي تواريخ صحيحة. على سبيل المثال، يمكنك حساب
                كم يوماً مضى على حدث تاريخي معين، أو حساب كم سنة بين تاريخين في
                القرن الماضي. طالما أن التواريخ صحيحة ومنطقية، ستحصل على نتائج
                دقيقة.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ماذا تعني "أيام العمل التقريبية" في النتائج؟
                </h3>
              </div>
              <div className="info-section-body">
                "أيام العمل التقريبية" هي عدد أيام العمل المتوقعة بين التاريخين،
                بافتراض أسبوع عمل من 5 أيام (من الأحد إلى الخميس، أو من الاثنين
                إلى الجمعة حسب البلد). يتم حسابها بضرب عدد الأسابيع في 5. هذا
                الرقم تقريبي لأنه لا يأخذ في الاعتبار الإجازات الرسمية أو
                الأعياد الوطنية. يُستخدم هذا الرقم بشكل شائع في:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>حساب الرواتب والأجور</li>
                  <li>إدارة المشاريع وتقدير ساعات العمل</li>
                  <li>حساب الإجازات والعطلات</li>
                  <li>تقييم إنتاجية الموظفين</li>
                </ul>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  هل تحفظ الحاسبة بياناتي الشخصية؟
                </h3>
              </div>
              <div className="info-section-body">
                لا، جميع الحسابات تتم بالكامل في متصفحك (Client-side)، ولا يتم
                إرسال أي بيانات إلى خوادمنا. هذا يعني:
                <ul style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>خصوصيتك محمية بالكامل</li>
                  <li>لا نحفظ أي تواريخ تدخلها</li>
                  <li>لا نتتبع استخدامك للحاسبة</li>
                  <li>يمكنك استخدام الحاسبة بثقة تامة</li>
                </ul>
                يمكنك حتى استخدام الحاسبة بدون اتصال بالإنترنت بعد تحميل الصفحة
                للمرة الأولى.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  كيف أحسب عدد أيام العمل الفعلية (مع استبعاد الإجازات)؟
                </h3>
              </div>
              <div className="info-section-body">
                الحاسبة تعطيك "أيام العمل التقريبية" التي تفترض أسبوع عمل من 5
                أيام. لحساب أيام العمل الفعلية مع استبعاد الإجازات والأعياد
                الرسمية، يمكنك:
                <ol style={{ marginTop: "10px", lineHeight: "1.8" }}>
                  <li>استخدام النتيجة التقريبية من الحاسبة</li>
                  <li>طرح عدد الإجازات الرسمية في بلدك خلال الفترة</li>
                  <li>طرح أيام الإجازات المرضية أو الشخصية إن وجدت</li>
                </ol>
                مثال: إذا أعطتك الحاسبة 260 يوم عمل تقريبي، وكان هناك 10 إجازات
                رسمية، فإن أيام العمل الفعلية = 260 - 10 = 250 يوم عمل.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default DateCalculatorGregorian;